import { defineStore } from 'pinia'

import { apiClientDB } from '@/config_sessions'

export const useOpeningHoursStore = defineStore({
    id: 'openinghours',

    state: () => ({
        regularHours: {},
        regularHoursVersions: [],
        irregularHours: [],
        closingDays: [],
        loading: false,
        error: null
    }),

    getters: {

    },
    
    actions: {
      async initializeDefaultOpeningHours(companyId) {
            try {
                // apiClientDB is its own axios instance and does NOT inherit the
                // global request interceptor, so the token goes on explicitly —
                // same pattern as fetchOpeningHours below. The endpoint is
                // admin-only (it overwrites existing hours).
                const response = await apiClientDB.post(`/initialize_openinghours/${companyId}`, {}, {
                    headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
                })
                return response.data
            } catch (error) {
                console.error('Failed to initialize default opening hours:', error)
                this.error = error
                throw error
            }
        },  

        async fetchOpeningHours() {
            this.loading = true
            try {
              const response = await apiClientDB.get('/openinghours', {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
              })

              const { regular_hours, regular_hours_versions, irregular_hours, closing_days } = response.data
      
              this.regularHours = regular_hours && typeof regular_hours === 'object' ? regular_hours : {}
              // The weekly hours' history: [{validFrom: 'YYYY-MM-DD' | null, hours}] (oldest first).
              this.regularHoursVersions = Array.isArray(regular_hours_versions) ? regular_hours_versions : []
              this.irregularHours = Array.isArray(irregular_hours) ? irregular_hours : []
              this.closingDays = Array.isArray(closing_days)
                ? closing_days.map(entry => ({
                    ...entry,
                    closingStartDate: entry.closingStartDate ? new Date(entry.closingStartDate) : null,
                    closingEndDate: entry.closingEndDate ? new Date(entry.closingEndDate) : null,
                    useRange: !!entry.useRange
                  }))
                : []

              const isEmpty = (
                !regular_hours || Object.keys(regular_hours).length === 0
              ) && (
                !Array.isArray(irregular_hours) || irregular_hours.length === 0
              ) && (
                !Array.isArray(closing_days) || closing_days.length === 0
              )

              return isEmpty
            } catch (error) {
              console.error('Failed to fetch opening hours:', error)
              this.error = error
              return true // assume empty on error
            } finally {
              this.loading = false
            }
        },
      
        // validFrom (weekly hours only): 'today' (the default) | 'YYYY-MM-DD' | 'always' —
        // "I corrected a mistake", the only choice that changes the figures of the past.
        async saveOpeningHours({ regularHours, irregularHours, closingDays, validFrom = 'today' }) {
            try {
                await apiClientDB.post('/openinghours', {
                    regular_hours: regularHours,
                    irregular_hours: irregularHours,
                    closing_days: closingDays,
                    valid_from: validFrom,
                }, {
                    headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
                })
        
                // ✅ Update store values so change detection resets
                this.regularHours = structuredClone(regularHours)
                this.irregularHours = structuredClone(irregularHours)
                this.closingDays = structuredClone(closingDays)
            } catch (error) {
                console.error('Failed to save opening hours:', error)
                this.error = error
            }
        }
    }
})